import React from 'react';
import ProviderApprovals from '../../components/AdminNext/ProviderApprovals';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };
  return {
    title: 'Provider approvals — Bas Recovery Admin',
    component: <HeadLessLayout><ProviderApprovals /></HeadLessLayout>
  };
}

export default action;
